import { logError } from 'src/loggingManager';
import { makePublicServiceRequest } from './fetchClient';

const FINISH_LIST_ENDPOINT = 'https://previews.cimpress.io/v2/finishes:all';

export interface FinishData {
    id: string;
    name: string;
    scene: {
        channel: string;
        baseTexture: {
            url: string;
            dpi?: number;
        };
        bumpScale: number;
    };
}

export const getFinishList = async (): Promise<FinishData[]> => {
    const response = await makePublicServiceRequest<FinishData[]>({
        url: FINISH_LIST_ENDPOINT,
        method: 'GET',
    });

    // Filter for scene finishes only
    if (response.ok) {
        return response.data.filter((finish) => !!finish.scene);
    }

    const errorMsg = `Unable to retrieve finish list: (${response.status}) ${response.statusText}`;
    logError(errorMsg);
    throw Error(errorMsg);
};
